<template>
  <div
    class="d-none d-lg-flex flex-column transition-menu bg-white px-0"
    :style="`width: ${isToolBarOpen ? '250' : '80'}px;
          min-width: ${isToolBarOpen ? '250' : '80'}px; z-index:1`"
  >
    <div
      class="d-none d-lg-flex flex-column bg-white
        position-fixed h-100 shadow-sm transition-menu"
      :style="`width: ${isToolBarOpen ? '250' : '80'}px;`"
    >
      <div
        v-if="!isMenuOpen"
        class="d-none d-lg-flex h-100 bg-gray-transparent position-absolute"
        style="top:0; bottom: 0; right: 0; left: 0; z-index: 1"
      />
      <v-menu
        :list="list"
        :open="isToolBarOpen"
      />
      <div
        class="fixed-bottom"
        :style="`left: ${isToolBarOpen ? '230' : '60'}px;
        right: unset; bottom: 60px; transition: all 0.7s`"
      >
        <div
          class="rounded-circle btn-chevron-collapse d-flex"
          :class="isMenuOpen ? 'bg-white cursor-pointer' : 'bg-non-transparent'"
          @click="openToolBar"
        >
          <div class="m-auto">
            <v-icon
              :icon="isToolBarOpen ? 'chevron-left' : 'chevron-right'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import data from '@/assets/data/dashboardMenuList.json';

import Menu from '@/components/common/layout/Menu.vue';

export default {
  components: {
    'v-menu': Menu,
  },
  data() {
    return {
      active: 'Dashboard',
      list: data.list,
    };
  },
  computed: {
    ...mapGetters({
      isToolBarOpen: 'ui/isToolBarOpen',
      isMenuOpen: 'ui/isMenuOpen',
    }),
  },
  methods: {
    ...mapActions({
      toolbarAction: 'ui/openToolBar',
    }),
    openToolBar() {
      if (this.isMenuOpen) { this.toolbarAction() }
    },
  },
};
</script>

<style scoped>
.transition-menu {
  transition: all 0.7s;
  z-index: 10;
}
.transition-icon-left {
  transform: rotate(0deg);
}
.transition-icon-right {
  transform: rotate(180deg);
}
.btn-chevron-collapse {
  width: 40px;
  height: 40px;
  font-size: 20px;
  box-shadow:4px 0px 6px -3px rgba(0,0,0,0.2)!important;
}

.bg-gray-transparent {
   background-color: rgba(0, 0, 0, 0.2);
}
.bg-non-transparent {
   background-color: #cccccc;
}
</style>
